import React, { FC, useRef, CSSProperties } from 'react';
import { ISFSProduct } from 'mod/feature/interface';
import { Button } from 'antd';
import styles from './index.module.less';
import { getActivityStatus } from 'base/utils/flashsale';
import cn from 'classnames';
import { ActivityTime } from '@base/shop/SFSItemCompts/ActivityTime';
import { ProductOptions } from '@base/shop/SFSItemCompts/ProductOptions';
import { PriceAndStock } from '@base/shop/SFSItemCompts/PriceAndStock';
import SuperFlashsaleTag from '@base/shop/SFSItemCompts/SuperFlashsaleTag';
import PicAndMask from '@base/shop/SFSItemCompts/PicAndMask';
import ProductName from '@base/shop/SFSItemCompts/ProductName';
import { useRouter } from 'next/router';

type IProps = {
    item: ISFSProduct;
    currentTime: number;
    showType?: 'default' | 'btnTime'; // 按钮显示时间
    className?: string;
    style?: CSSProperties;
    onClick?: (product) => void;
    canLinkJump?: boolean;
}

const SuperFlashsaleItem: FC<IProps> = (props) => {
    const {
        item,
        item: {
            variant,
            startTime,
            endTime,
            userLimit,
            activityStock,
            title,
        },
        showType = 'default',
        currentTime,
        className,
        canLinkJump = true,
        onClick,
        ...resetProps
    } = props

    const router = useRouter();

    const imgWrapRef = useRef<HTMLDivElement>(null);
    const status = getActivityStatus(currentTime, startTime, endTime);
    const canJump = canLinkJump && status === 'inProgress' && activityStock > 0;

    const onClickItem = () => {
        onClick?.(variant)
    }

    return(
        <div
            className={cn(styles['item-container'], className)}
            onClick={onClickItem}
        >
            {showType === 'default' && (
                <ActivityTime data={item} currentTime={currentTime}/>
            )}

            <div
                className={cn(styles['sfs-item-wrap'], 'relative g-sfs-item')}
                {...resetProps}
            >
                <SuperFlashsaleTag product={variant}/>

                <div
                    className={cn(
                        styles['info'],
                        'g-info',
                        { 'pointer': canJump }
                    )}
                    onClick={() => canJump && router.push(variant.url)}
                >
                    <PicAndMask
                        imgWrapRef={imgWrapRef}
                        item={item}
                        currentTime={currentTime}
                    />

                    <ProductName
                        status={status}
                        title={title}
                        variant={variant}
                    />

                    <PriceAndStock
                        product={variant}
                        activityStock={activityStock}
                        status={status}
                    />
                </div>

                <div className={styles['btn-wrap']}>
                    {showType === 'btnTime' ? (
                        <Button
                            className={styles['btn-time']}
                            block
                            type={'primary'}
                            size={'small'}
                        >
                            <ActivityTime data={item} currentTime={currentTime}/>
                        </Button>
                    ) : (
                        <ProductOptions
                            variantId={variant.variantId}
                            activityStock={activityStock}
                            status={status}
                            userLimit={userLimit}
                            getImgSrc={() => {
                                const img = imgWrapRef.current?.querySelector('img');
                                if (img) {
                                    return img.currentSrc;
                                }
                            }}
                        />
                    )}

                </div>
            </div>
        </div>

    );
};

export default SuperFlashsaleItem